// extracted by mini-css-extract-plugin
export var bounce = "plan-card-module--bounce--c8c55";
export var chosen = "plan-card-module--chosen--66fe5";
export var container = "plan-card-module--container--fe982";
export var lock = "plan-card-module--lock--19e2f";
export var ordered = "plan-card-module--ordered--946a0";
export var title = "plan-card-module--title--91471";